export default function ExploreTagItem({label, isFixedToSmall = false, isHighlighted = false}) {
    return <button className={`max-w-full h-max text-left group btn ${isFixedToSmall ? "btn-xs text-xs" : "btn-sm text-sm md:text-base"} normal-case rounded-full btn-neutral btn-soft ${isHighlighted ? "font-bold border-2 border-primary border-dotted" : "font-normal"}`}>
        { label }
    </button>
}